import * as React from "react";
import { SVGProps } from "react";

const Aeternity = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 940" {...props}>
    <g fill="#de3f6b">
      <path d="M432 0h82.2c128.4 12.6 247.2 77.2 335.2 170.2 182.6 191.6 283 462 515.4 604.6 168 103.2 403 18.8 485.6-155.4 42-.8 84.2-.8 126.2-.6-57.8 177-226.2 304.2-410.4 321.2h-67.8c-113.4-9.4-223.6-53-309.4-128.4C1064.4 706 984.4 561.2 887.6 432.2c-83.2-114-168.2-242.2-306-294-170.2-63.8-378.2 36-440.2 205.6C86.8 483.4 131.2 656.6 253.2 746c91.4 70.8 218.8 97.2 328.6 56 122-44 212.6-144 282-250 27.4 39.2 54 79 80.4 119-108 136-257.8 252.8-436 269h-73C210.6 924.4 15.4 733.6 0 508.2v-73.8C14.6 209.4 207.2 16.4 432 0" />
      <path d="M1493.8 0h68.2c226.6 14.8 419.4 209.4 438 434.8v115.6c-187 1.8-374.2.6-561.2.8.2-33.8.2-67.4 0-101.2 147.8-.4 295.4.6 443-.4-10.4-59.8-24-121-59.4-171.6-86.4-132-269-186-415-128.8-116.4 43.2-204 137.8-271.6 238.8-26-37.4-51.8-75.2-76.8-113.4 106.6-138 255.4-257.4 434.8-274.6" />
    </g>
  </svg>
);

export default Aeternity;
